import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cart-widget__overview" }
const _hoisted_2 = { class: "cart-widget__overview__price" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, " Gesamt einmalig ", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, " Gesamt pro Monat ", -1)
const _hoisted_7 = { class: "cart-widget__overview__actions" }

import BaseButton from '@/components/BaseButton.vue';
import {
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { formatNumber } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCartOverview',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const router = useRouter();
const store = useStore();
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');

const totalPerMonth = computed(() => store.getters['cart/perMonth']);
const totalPerMonthFormatted = computed(() => formatNumber(totalPerMonth.value, 2));
const totalOneTime = computed(() => store.getters['cart/oneTime']);
const totalOneTimeFormatted = computed(() => formatNumber(totalOneTime.value, 2));

const gotoOrder = () => {
  if (!isOrderPage.value) {
    router.push('/bestellung/adresse/');
    emit('close');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (totalOneTime.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, _toDisplayString(totalOneTimeFormatted.value) + " € ", 1)
          ]))
        : _createCommentVNode("", true),
      (totalPerMonth.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(totalPerMonthFormatted.value) + " € ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["cart-widget__overview__entry", { 'inactive': isOrderPage.value }])
      }, [
        _createVNode(BaseButton, {
          "link-type": "button",
          color: "red-orange",
          width: "full",
          "text-align": "center",
          onClick: _withModifiers(gotoOrder, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Jetzt bestellen ")
          ]),
          _: 1
        })
      ], 2)
    ])
  ]))
}
}

})